module.exports = __webpack_public_path__ + "static/media/img150.df2b6a0e.jpg";